<template>
  <div class="ren-decoration-items">
    <div class="ren-decoration-field-group">
      <label>标题</label>
      <RrInput
        :value="title"
        :disabled="readonly"
        @update:value="(val) => patch({ title: String(val ?? '') })"
      />
    </div>
    <div class="ren-decoration-field-group">
      <label>图文详情</label>
      <textarea
        class="ren-control ren-decoration-textarea"
        :disabled="readonly"
        :value="html"
        @input="onHtmlInput"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { RrInput } from '@xjlv2/ui'
import { mergeWidgetProps, type WidgetSettingsProps } from '../../types'

const props = withDefaults(defineProps<WidgetSettingsProps>(), {
  readonly: false
})

const emit = defineEmits<{
  'update:props': [props: Record<string, unknown>]
}>()

const title = computed(() => String(props.component.props?.title ?? ''))
const html = computed(() => String(props.component.props?.html ?? ''))

function patch(partial: Record<string, unknown>) {
  emit('update:props', mergeWidgetProps(props.component, partial))
}

function onHtmlInput(event: Event) {
  patch({ html: (event.target as HTMLTextAreaElement).value })
}
</script>
